import React, { Component } from "react";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import { createMuiTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import _appRoute from "./routes/routes";
import _miniVariantDrawer from "./components/SideMenu/MiniVariantDrawer";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import { setGlobalParam } from "./reducers/reducers";
import DataHqCompany from "./Controls/Select/DataHqCompany";
import { Auth } from "aws-amplify";
import { history } from "./store";
const theme = createMuiTheme({
  typography: {
    fontSize: 13,
  },
  palette: {
    primary: {
      main: "#00a19c",
    },
    secondary: {
      main: "#EDEDED",
    },
  },
  datePicker: {
    selectColor: "#00a19c",
    calendarYearBackgroundColor: "#00a19c",
  },
});

class App extends Component {
  getUser() {
    const { user, dispatch } = this.props;
    let current_user = {};
    Auth.currentAuthenticatedUser()
      .then((value) => {
        current_user = value;
        let user_attribute = { ...user };
        user_attribute.email = current_user.attributes.email;
        user_attribute.company_email =
          current_user.attributes["custom:company_email"];
        user_attribute.username =
          current_user.signInUserSession.accessToken.payload.username;
        user_attribute.role = current_user.signInUserSession
          ? current_user.signInUserSession.idToken.payload[
              "cognito:preferred_role"
            ]
          : null;
        user_attribute.group = "";
        if (
          "cognito:groups" in current_user.signInUserSession.idToken.payload
        ) {
          user_attribute.group =
            current_user.signInUserSession.idToken.payload["cognito:groups"][0];
        }

        DataHqCompany.map((values, index) => {
          let company_email = current_user.attributes["custom:company_email"];
          let companyEmail = company_email.split(",");
          companyEmail.forEach((email) => {
            if (email.includes(values.value)) {
              user_attribute.hq_name = values.value;
            }
          });
        });

        dispatch({
          type: setGlobalParam,
          storage: "user",
          response: user_attribute,
        });
      })
      .catch((err) => {
        toast.error(err);
        history.push("/login");
      });
  }

  render() {
    const { user } = this.props;
    const isUserValid = user.email == "" ? false : true;
    if (user.email == "") {
      this.getUser();
    }
    return (
      <div className="app">
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ToastContainer
              position="bottom-center"
              newestOnTop
              closeOnClick
              autoClose={5000}
              pauseOnHover
              rtl={false}
              pauseOnVisibilityChange
              draggable
            />
            <div className="app-body">
              <_miniVariantDrawer />
              <main className="main">{isUserValid ? <_appRoute user={user}/> : ""}</main>
            </div>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    user: state.reducer.user,
  }),
  (dispatch) => ({ dispatch })
)(App);



// WEBPACK FOOTER //
// ./src/App.js